export const male_headwear = [ //An array of each Male Headwear ID, Atlas, and name. There are 39.
  /* Headwear that's available in-game from Barbershop. */
  {
    id: 'headwear0', 
    atlas: '',
    name: 'No headwear' //Show name in textbox.
  },
  {
    id: 'headwear16',
    atlas: 'atlas17',
    name: 'Knight helmet', /* Knight armor */
    disable_hair: 1
  },
  {
    id: 'headwear21',
    atlas: 'atlas17',
    name: 'Gold tiara' /* Nobility outfit */
  },
  {
    id: 'headwear15',
    atlas: 'atlas17',
    name: 'Golden crown' /* Medieval ruler outfit */
  },
  {
    id: 'headwear4',
    atlas: 'atlas17',
    name: 'Professor cap' /* Professor outfit */
  },
  {
    id: 'headwear27',
    atlas: 'atlas17',
    name: 'Football helmet', /* Sports fan outfit */
    disable_hair: .5
  },
  {
    id: 'headwear33',
    atlas: 'atlas18',
    name: 'Black bowler hat' /* Eulogy Jones' outfit */
  },
  {
    id: 'headwear23',
    atlas: 'atlas17',
    name: 'Sheriff hat' /* Sheriff's duster */
  },
  {
    id: 'headwear40',
    atlas: 'atlas18',
    name: 'Three Dog\'s head wrap', /* Three Dog's outfit */
    disable_hair: .5
  },
  {
    id: 'headwear31',
    atlas: 'atlas18',
    name: 'Minuteman hat' /* Minuteman uniform */
  },
  {
    id: 'headwear3',
    atlas: 'atlas17',
    name: 'Military helmet' /* Military fatigues */
  },
  {
    id: 'headwear22',
    atlas: 'atlas17',
    name: 'Combat armor helmet' /* Combat armor */
  },
  {
    id: 'headwear25',
    atlas: 'atlas17',
    name: 'Radiation suit helmet', /* Radiation suit */
    disable_hair: .5
  },
  {
    id: 'headwear10',
    atlas: 'atlas17',
    name: 'Wasteland darklight cowl', /* Wasteland gear */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear19',
    atlas: 'atlas17',
    name: 'Cat ears',
    disable_hair: 1
  },
  {
    id: 'headwear34',
    atlas: 'atlas18',
    name: 'Pirate hat and eyepatch'
  },
  {
    id: 'headwear29',
    atlas: 'atlas18',
    name: 'Silver Shroud hat' /* Alternatively Fedora, Formal Hat, or Trilby. */
  },
  {
    id: 'headwear28',
    atlas: 'atlas17',
    name: 'Aviator cap',
    disable_hair: 1
  },
  {
    id: 'headwear2',
    atlas: 'atlas17',
    name: 'Mascot head',
    disable_hair: 1
  },
  {
    id: 'headwear36',
    atlas: 'atlas18',
    name: 'Party hat'
  },


  /* Headwear that's available from outfits or are locked. */
  {
    id: 'headwear1', 
    atlas: 'atlas17', 
    name: 'Metal helmet' /* Metal armor */
  },
  {
    id: 'headwear32',
    atlas: 'atlas18',
    name: 'T-45 helmet', /* T-45 power armor */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear7',
    atlas: 'atlas17',
    name: 'T-51 helmet', /* T-51 power armor */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear8',
    atlas: 'atlas17',
    name: 'T-60 helmet', /* T-60 power armor */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear9',
    atlas: 'atlas17',
    name: 'X-01 Mk VI helmet', /* X-01 Mk VI power armor */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear11',
    atlas: 'atlas17',
    name: 'Ghost costume', /* Ghost costume */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear17',
    atlas: 'atlas17',
    name: 'Sailor hat' /* Lifeguard outfit */
  },
  {
    id: 'headwear20',
    atlas: 'atlas17',
    name: 'Baseball cap' /* Baseball uniform */
  },
  {
    id: 'headwear24',
    atlas: 'atlas17',
    name: 'Elf hat' /* Elf outfit */
  },
  {
    id: 'headwear30',
    atlas: 'atlas18',
    name: 'Santa hat' /* Santa suit */
  },
  {
    id: 'headwear35',
    atlas: 'atlas18',
    name: 'Pilgrim hat' /* Pilgrim outfit */
  },
  {
    id: 'headwear37',
    atlas: 'atlas18',
    name: 'Skeleton mask', /* Skeleton costume */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear38',
    atlas: 'atlas18',
    name: 'Swimcap and goggles', /* Swimsuit outfit */
    disable_hair: 1
  },
  {
    id: 'headwear39',
    atlas: 'atlas18',
    name: 'Synth field helmet', /* Synth armor */
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  },
  {
    id: 'headwear41',
    atlas: 'atlas21',
    name: 'Top hat' /* Mayor outfit */
  },
  {
    id: 'headwear42',
    atlas: 'atlas21',
    name: 'Clergy hat' /* Clergy outfit */
  },
  {
    id: 'headwear12',
    atlas: 'atlas17',
    name: 'Shower cap',
    disable_hair: 1
  },
  {
    id: 'headwear13',
    atlas: 'atlas17',
    name: 'Surgery bandages',
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  }, 
  {
    id: 'headwear57',
    atlas: 'mysterious',
    name: 'Mysterious Stranger',
    disable_hair: 1,
    disable_beard: 1,
    disable_feature: 1
  }
]